import React from 'react'

import ConfirmEmail from '@images/confirm_email.svg'

export default (props) =>
  <img {...props} src={ConfirmEmail}></img>